import * as React from 'react';
import {Field, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {DatePickerField, OnOffField, RenderField, Validators} from './Fields/_Fields';
import SelectField from './Fields/SelectField';
import * as Dictionary from 'Models/Dictionary';
import * as UserModule from 'Modules/UserModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {getCounties} from "Redux/Actions/UserActions";
import {Province} from "API/Region/Region.Enums";
import {OptionsElement} from "Models/ViewManagementModel";
import {prepareCounties, prepareVoivodeships} from "components/Layout/Form/AddUserForm.Services";

type DispatchProps = ReturnType<typeof mapDispatchToProps>

type ConnectedProps = {
    t: Function;
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    roleName?: any;
};

type Props = {
    typeForm: 'edit' | 'add';
};

const AddUserForm = (props: InjectedFormProps & ConnectedProps & Props & DispatchProps) => {
    const {handleSubmit, t, userStore} = props;
    const options = Dictionary.GenerateList(Dictionary.RoleNameArray);
    const isFleetOwner = props.roleName != undefined && props.roleName.value == UserModule.UserEnumTypes.RoleName.FLEET_OWNER;
    const voivodeships = props.roleName != undefined && props.roleName.value == UserModule.UserEnumTypes.RoleName.TECHNICIAN
      ? prepareVoivodeships(props.userStore.provinces)
      : []
    const counties = props.roleName != undefined && props.roleName.value == UserModule.UserEnumTypes.RoleName.TECHNICIAN
      ? prepareCounties(props.userStore.counties)
      : []

    return (
        <>
            <h3 className="form__title">
                {props.typeForm == 'edit' ? t('editUser') : t('addUser')}
            </h3>
            <form className="form" onSubmit={handleSubmit}>
                {userStore.error.createUserErr &&
                <p className="form-field__error" date-e2eid={"serverError"}>
                    {t(`errors:${userStore.error.createUserErr.errorSubcode}`)}
                </p>}
                <Field
                    name="roleName"
                    disabled={props.typeForm == 'edit'}
                    component={SelectField}
                    options={options}
                    type="text"
                    placeholder={t('roleName')}
                    label={t('roleName')}
                    validate={[Validators.required]}
                    e2eId={"roleNameInput"}
                />
                <Field name="email" disabled={props.typeForm == 'edit'} component={RenderField} type="text"
                       placeholder={t('loginLabel')} label={t('loginLabel')} e2eId={"loginInput"}
                       validate={[Validators.required, Validators.email]}/>
                <Field name="firstName" component={RenderField} type="text" placeholder={t('firstName')}
                       label={t('firstName')} e2eId={"firstInput"} validate={[Validators.required]}/>
                <Field name="lastName" component={RenderField} type="text" placeholder={t('lastName')}
                       label={t('lastName')} e2eId={"lastInput"} validate={[Validators.required]}/>
                <Field name="phoneNumber" component={RenderField} type="text" placeholder={t('phone')}
                       label={t('phone')} e2eId={"phoneInput"}
                       validate={isFleetOwner ? [Validators.phone] : [Validators.required, Validators.phone]}/>
                {props.typeForm == 'edit' && (
                    <Field
                        name="status"
                        disabled={true}
                        component={RenderField}
                        type="text"
                        label={t('status')}
                        format={value => {
                            return t(`dictionary:${value}`);
                        }}
                        e2eId={"statusInput"}
                    />
                )}
                {props.roleName != undefined && props.roleName.value == UserModule.UserEnumTypes.RoleName.TECHNICIAN && (
                    <React.Fragment>
                        <div className="form-field">
                            <Field name="city" component={RenderField} type="text" placeholder={t('city')}
                                   label={t('city')} e2eId={"cityInput"} validate={[Validators.required]}/>
                            <Field
                              name="provinces"
                              component={SelectField}
                              options={voivodeships}
                              // tutaj typy są nie zgodne, typ z react-select i z WrappedFieldProps i dopasowanie
                              // typów skutkuje pojawieniem się błędu na propsie options
                              onBlur={(event: any) => {
                                const preparedVoivodeships = Object.entries<typeof voivodeships[0]>(event)
                                  .filter(([key]) => !isNaN(Number(key)))
                                  .map(([, voivodeshipValue]) => voivodeshipValue.value)

                                props.getCounties(preparedVoivodeships)
                              }}
                              onClose
                              placeholder={t('voivodeship')}
                              noOptionsMessage={() => t('noOptions')}
                              label={t('voivodeship')}
                              validate={[Validators.required, Validators.notEmptyArray]}
                              isMulti
                              closeMenuOnSelect={false}
                              hideSelectedOptions
                              required
                            />
                            <Field
                              name="counties"
                              component={SelectField}
                              options={counties}
                              type="text"
                              placeholder={t('counties')}
                              noOptionsMessage={() => t('noOptions')}
                              label={t('counties')}
                              validate={[Validators.required, Validators.notEmptyArray]}
                              isMulti
                              closeMenuOnSelect={false}
                              hideSelectedOptions
                              required
                            />
                            <Field name="insuranceEndDate" component={DatePickerField}
                                   wrapperClassName={'form-left-col'} placeholder={t('endDate')}
                                   e2eId={"endDateInput"} label={t('insurancePolicyEndDate')}/>
                        </div>
                        <Field name="companyName" component={RenderField} type="text" placeholder={t('company')}
                               label={t('company')} e2eId={"companyInput"} validate={[Validators.required]}/>
                        <Field name="criminalBackgroundCheck" component={OnOffField} type="checkbox"
                               placeholder={t('dbsCheck')} label={t('dbsCheck')} label2={t('dbsCheck2')}
                               e2eId={"dbsCheckInput"}/>
                    </React.Fragment>
                )}

                {props.roleName != undefined && props.roleName.value == UserModule.UserEnumTypes.RoleName.FLEET_OWNER && (
                    <React.Fragment>
                        <Field name="accountingEmail" component={RenderField} type="text"
                               placeholder={t('accountingEmail')} label={t('accountingEmail')}
                               e2eId={"accountingEmailInput"}/>
                    </React.Fragment>
                )}
            </form>
        </>
    );
};

function mapStateToProps(state: any) {
    const selector = formValueSelector('addUserForm');
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore,
        roleName: selector(state, 'roleName')
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        getCounties: (voivodeships: Province[]) => { dispatch(getCounties(voivodeships)) }
    };
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation(['forms', 'errors', 'dictionary']),
    reduxForm({
        form: 'addUserForm',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(AddUserForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/AddUserForm.tsx